<template>
    <a v-if="videoUrl"
        class="inline-flex items-center justify-center rounded-xl border border-gray-300 px-4 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:border-gray-400 hover:bg-gray-50 active:bg-gray-100"
        href="#" @click.prevent="open = true"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"
            class="h-6 w-6 flex-none">
            <circle cx="12" cy="12" r="11.5" stroke="#D4D4D4"></circle>
            <path
                d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                fill="#A3A3A3" stroke="#A3A3A3"></path>
        </svg><span class="ml-2.5">Watch the video</span></a>

    <Dialog v-model:visible="open" modal header="Watch the video" :style="{ width: '48rem' }" @hide="pauseVideo">
        <video ref="videoEl" :src="videoUrl" controls autoplay class="w-full rounded-xl bg-black"></video>
    </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import Dialog from 'primevue/dialog';

defineProps({
    videoUrl: { type: String, default: '' },
});

const open = ref(false);
const videoEl = ref(null);

const pauseVideo = () => {
    videoEl.value?.pause();
};
</script>
